import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material';
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';
import Condicional from '../../../Layout/Condicional';
import CloseIcon from '@mui/icons-material/Close';

import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable';
import { useNavigate } from 'react-router-dom';

import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev';
import { DrgConteudoPermitidoInterface, DrgCorrespondenciaDetalheInterface, DrgCorrespondenciaInterface } from '../../../ImportBackend/Interfaces/DrgInterfaces';
import BackEndAPI from '../../../Services/BackEndAPI';
import { MensagemTipo } from '../../../GlobalStates/MensagemState';
import DataTableCrud from '../../../DevComponents/DataTableCrud';
import ClientesDeParaInput from './DRGClientesDeParaInput';
import ClsUtils from 'zlib-utils';
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces';
import ComboBox from '../../../DevComponents/ComboBox';
import { GrupoDRGInterface, GrupoDRGTypes } from '../../../ImportBackend/types/ConstantesDataTypes';

export interface CrudDetalhePropsInterface {
  valorUnico: boolean
  conteudoPermitido: Array<DrgConteudoPermitidoInterface>
}

export default function DRGClientesDePara () {

  const navigate = useNavigate()

  const [editarDetalhe, setEditarDetalhe] = useState<boolean>( false )
  const [selecioarDrgCorrespondencia, setSelecioarDrgCorrespondencia] = useState<boolean>( true )

  const clsApi: BackEndAPI = new BackEndAPI()
  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto
  const { loginState } = contexto

  const [erros] = useState( {} )

  const [rsDetalhe, setRsDetalhe] = useState<Array<DrgCorrespondenciaDetalheInterface>>( [] )
  const [rsDrgCorrespondencia, setRsDrgCorrespondencia] = useState<DrgCorrespondenciaInterface>()
  const [rsPesquisaCorrespondencia, setRsPesquisaCorrespondencia] = useState<Array<DrgCorrespondenciaInterface>>( [] )

  const resetDados = {
    grupo: ''
  }

  const [dados, setDados] = useState<typeof resetDados>( resetDados )
  const clsUtils: ClsUtils = new ClsUtils()

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'ERP',
      campo: 'conteudoBancoDados',
      alinhamento: 'left'
    },
    {
      cabecalho: 'DRG',
      campo: 'conteudoDrg',
      alinhamento: 'left',
      format: ( v ) => rsDrgCorrespondencia?.conteudoPermitido.find( cp => cp.chave === v )?.descricaoConteudo || v
    }
  ]

  const CabecalhoPesquisaCorrespondencia: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    }
  ]

  const pesquisarCorrespondenciasDoGrupo = ( rsGrupoDRG: GrupoDRGInterface ) => {

    if ( rsGrupoDRG ) {

      const query = `
        getDrgCorrespondenciasPorGrupo(grupo: "${rsGrupoDRG.descricao}") {
          idDrgCorrespondencia
          grupo
          descricao
          campo
          valorUnico
          conteudoPermitido {
            descricaoConteudo
            chave
          }
        }
      `

      clsApi.query<Array<DrgCorrespondenciaInterface>>( query, 'getDrgCorrespondenciasPorGrupo', 'Pesquisando De Para...', contexto ).then( rs => {
        setRsPesquisaCorrespondencia( rs )
        setDados( { grupo: rsGrupoDRG.descricao } )
        setSelecioarDrgCorrespondencia( true )
        setEditarDetalhe( false )

      } ).catch( ( e ) => {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Consultar De / Para!',
          exibir: true,
          mensagem: e.message,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } )

    } else {
      setRsPesquisaCorrespondencia( [] )
      setDados( resetDados )
      setSelecioarDrgCorrespondencia( false )
      setEditarDetalhe( false )
    }



  }

  const pesquisarDetalheCorrespondencia = ( rsCorrespondencia: DrgCorrespondenciaInterface ) => {

    if ( rsCorrespondencia && rsCorrespondencia.idDrgCorrespondencia ) {

      setRsDrgCorrespondencia( rsCorrespondencia );

      const query = `
        getDrgCorrespondenciaDetalhe(idCliente: ${loginState.idClienteAtual}, idDrgCorrespondencia: ${rsCorrespondencia.idDrgCorrespondencia}) {
          idDrgCorrespondenciaDetalhe
          idDrgCorrespondencia
          conteudoBancoDados
          conteudoDrg
        }
      `

      clsApi.query<Array<DrgCorrespondenciaDetalheInterface>>( query, 'getDrgCorrespondenciaDetalhe', 'Pesquisando De Para...', contexto ).then( rs => {
        setRsDetalhe( rs )
        setEditarDetalhe( true )
        setSelecioarDrgCorrespondencia( false )

      } ).catch( ( e ) => {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Consultar De / Para!',
          exibir: true,
          mensagem: e.message,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } )

    } else {

      setRsDetalhe( [] )
      setEditarDetalhe( false )

    }

  }

  const onIncluirAlterarDetalhe = ( rsRegistro: DrgCorrespondenciaDetalheInterface ) => {

    const tmpRegistro: DrgCorrespondenciaDetalheInterface = {
      conteudoBancoDados: rsRegistro.conteudoBancoDados,
      conteudoDrg: rsRegistro.conteudoDrg,
      idDrgCorrespondencia: rsDrgCorrespondencia ? rsDrgCorrespondencia.idDrgCorrespondencia as number : 0,
      idCliente: loginState.idClienteAtual as number,
      idDrgCorrespondenciaDetalhe: rsRegistro.idDrgCorrespondenciaDetalhe || 0
    }

    const mutation = `
      updateDrgCorrespondenciaDetalhe(dados: ${clsUtils.ConverterEmGql( tmpRegistro )}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'updateDrgCorrespondenciaDetalhe', 'Atualizando "De Para"...', contexto ).then( rs => {

      if ( !rs.ok ) {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Atualizar De / Para!',
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } else {
        pesquisarDetalheCorrespondencia( rsDrgCorrespondencia as DrgCorrespondenciaInterface )
      }


    } ).catch( ( e ) => {

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro ao Atualizar De / Para!',
        exibir: true,
        mensagem: e.message,
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )

  }

  const onExcluirDetalhe = ( rsRegistro: DrgCorrespondenciaDetalheInterface ) => {

    const mutation = `
      delDrgCorrespondenciaDetalhe(idDrgCorrespondenciaDetalhe: ${rsRegistro.idDrgCorrespondenciaDetalhe}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'delDrgCorrespondenciaDetalhe', 'Atualizando "De Para"...', contexto ).then( rs => {

      if ( !rs.ok ) {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro ao Atualizar De / Para!',
          exibir: true,
          mensagem: rs.mensagem,
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

      } else {
        pesquisarDetalheCorrespondencia( rsDrgCorrespondencia as DrgCorrespondenciaInterface )
      }


    } ).catch( ( e ) => {

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro ao Atualizar De / Para!',
        exibir: true,
        mensagem: e.message,
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )

  }

  const onDrgCorrespondenciaSelecionada = ( rs: DrgCorrespondenciaInterface ) => {
    pesquisarDetalheCorrespondencia( rs )
  }

  const onCancelarEdicaoDetalhe = () => {
    setEditarDetalhe( false )
    setRsDetalhe( [] )
    setRsDrgCorrespondencia( undefined )
    setSelecioarDrgCorrespondencia( true )
  }

  const [currentPageOptions, setCurrentPageOptions] = useState<{ page: number; rowsPerPage: number }>( { page: 0, rowsPerPage: 10 } )

  const onChangeCurrentPageOptions = ( options: { page: number; rowsPerPage: number } ) => {
    setCurrentPageOptions( options )
  }

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>

          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Condicional condicao={!editarDetalhe}>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                <Typography component="h5" variant="h5" align="left">
                  Cadastro "De - Para"
                  <Typography variant="body2" gutterBottom>
                    Mapeamento de dados entre o ERP e o DRG
                  </Typography>
                </Typography>

                <IconButton onClick={() => navigate( '/' )}>
                  <CloseIcon />
                </IconButton>
              </Grid>

              <Grid item xs={12}>

                <ComboBox
                  dados={dados}
                  field='grupo'
                  label='Grupo'
                  erros={erros}
                  campoDescricao='descricao'
                  campoID='descricao'
                  opcoes={GrupoDRGTypes}
                  onChange={( v: GrupoDRGInterface ) => pesquisarCorrespondenciasDoGrupo( v )}
                />

                {/*
              <PesquisarTabela<DrgCorrespondenciaInterface>
                onChange={( v ) => pesquisarDetalheCorrespondencia( v )}
                field='idDrgCorrespondencia'
                fieldSet='idDrgCorrespondencia'
                label='De / Para'
                dados={dados}
                campoQueryPesquisaID='idDrgCorrespondencia'
                campoQueryPesquisa='pesquisa'
                camposRetornoQueryPesquisa='{idDrgCorrespondencia, descricao, conteudoPermitido {chave descricaoConteudo}}'
                campoLabelQueryPesquisa='descricao'
                nomeQueryPesquisa='getDrgCorrespondencias'
                nomeQueryPesquisaID='getDrgCorrespondenciaPorId'
                mensagemPesquisa='Procurando De / Para...'
                erros={erros}
                pesquisarTudoAoIniciar
                valorAtribuirLimpar={0}
              />
              */}

              </Grid>

              <Condicional condicao={selecioarDrgCorrespondencia}>
                <Grid item xs={12} sx={{ mt: 3 }}>
                  <DataTable<DrgCorrespondenciaInterface>
                    dados={rsPesquisaCorrespondencia}
                    onChangeCurrentPageOptions={( rs ) => onChangeCurrentPageOptions( rs )}
                    currentPageOptions={currentPageOptions}
                    cabecalho={CabecalhoPesquisaCorrespondencia} acoes={
                      [
                        { icone: 'edit_note', toolTip: 'De / Para', onAcionador: ( rs ) => onDrgCorrespondenciaSelecionada( rs ) },
                        // { icone: 'create', toolTip: 'Alterar', onAcionador: clsCrud.btEditar }
                      ]
                    } />
                </Grid>
              </Condicional>

            </Condicional>

            <Condicional condicao={editarDetalhe}>

              <Grid item xs={12} sx={{ mt: 3 }}>
                <Typography component="h5" variant="h5" align="left">
                  {rsDrgCorrespondencia?.grupo}
                </Typography>
              </Grid>

              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 3, mb: 3 }}>

                <Typography component="h5" variant="h5" align="left">
                  {rsDrgCorrespondencia?.descricao}
                  <Typography variant="body2" gutterBottom>
                    Edição dos mapeamentos "De - Para"
                  </Typography>
                </Typography>

                <IconButton onClick={() => onCancelarEdicaoDetalhe()}>
                  <CloseIcon />
                </IconButton>

              </Grid>

              <Grid item xs={12}>
                <DataTableCrud<DrgCorrespondenciaDetalheInterface, CrudDetalhePropsInterface>
                  tituloCrud='De - Para | ERP - DRG'
                  dados={[...rsDetalhe]}
                  cabecalho={Cabecalho}
                  ComponenteInputCrud={ClientesDeParaInput as any}
                  dadosIniciaisRegistro={{
                    conteudoBancoDados: rsDrgCorrespondencia?.valorUnico ? 'FIXO' : '',
                    conteudoDrg: '',
                    idCliente: loginState.idClienteAtual as number,
                    idDrgCorrespondencia: rsDrgCorrespondencia ? rsDrgCorrespondencia.idDrgCorrespondencia as number : 0,
                    idDrgCorrespondenciaDetalhe: 0
                  }}
                  onAlterar={( v ) => onIncluirAlterarDetalhe( v )}
                  onExcluir={( v ) => onExcluirDetalhe( v )}
                  onIncluir={( v ) => onIncluirAlterarDetalhe( v )}
                  props={{
                    valorUnico: rsDrgCorrespondencia?.valorUnico || false,
                    conteudoPermitido: rsDrgCorrespondencia?.conteudoPermitido || []
                  }}
                  permitirInclusao={rsDrgCorrespondencia?.valorUnico && rsDetalhe.length === 0 || !rsDrgCorrespondencia?.valorUnico}
                  rowsPerPageOptions={[5, 3, 7]}
                />
              </Grid>
            </Condicional>
          </Grid>

        </Paper >

      </Container >

      <ExibirJSONDev oque={['dados', dados, 'rsDrgCorrespondencia', rsDrgCorrespondencia, 'rsDetalhe', rsDetalhe]} />
    </>
  )
}